export default "__VITE_ASSET__Bor28Goe__"